import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestReporte } from '../clases/request-reporte';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RequestReportePuntoVenta } from '../clases/request-reporte-punto-venta';

@Injectable({
  providedIn: 'root'
})
export class ReporteService {

  constructor(private _http: HttpClient) { }

  requestReporte(datos: RequestReporte) {
    let url = environment.URL_BASE + "reporteAuthorization/detallado";

    return this._http.post(url, datos);
  }

  requestReportePuntoVenta(datos: RequestReportePuntoVenta) {
    let url =environment.URL_BASE+ "reporteAuthorization/detalladoPuntoVenta";
    return this._http.post(url, datos);
  }

  requestClienteAutocomplete(jsonEnvio) { //idEmpresa: number, idCentroCosto: number, idUsuario: number
    const url = environment.URL_BASE + "clienteAuthorization/getAutocomplete";
    return this._http.post(url, jsonEnvio);
  }

  requestCliente(idEmpresa: number, idCentroCosto: number, idUsuario: number) { //idEmpresa: number, idCentroCosto: number, idUsuario: number
    const url = environment.URL_BASE + "clienteAuthorization/get?idEmpresa=" + idEmpresa + "&idCentroCosto=" + idCentroCosto+"&idUsuario=" + idUsuario;
    return this._http.get(url);
  }

  multiDestinos(id: number) {
    const url = environment.URL_BASE + "reporteAuthorization/destinos?IdServicio=" + id;
    return this._http.get(url);
  }

  detalleServicio(idServicio: number) {
    const url = environment.URL_BASE + "servicioAuthorization/getDetalle?idServicio=" + idServicio;
    return this._http.get(url);
  }

  mapServicio(id: number, movil: number) {
    const url = environment.URL_BASE + "servicioAuthorization/GetTracking?idServicio=" + id + "&idConductor=" + movil;
    return this._http.get(url);
  }

  mapServicioSinAutetication(id: number, movil: number) {
    const url = environment.URL_BASE + "servicio/GetTracking?idServicio=" + id + "&idConductor=" + movil;
    return this._http.get(url);
  }

  requestReporteSinPaginacion(data: any) {
    console.log('reporte de para dockes')
    let url = environment.URL_REPORTE + 'reportes/detallado';
    let headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Credentials', 'true');

    if(environment.REPORTES_PERSONALIZADO && environment.REPORTES_PERSONALIZADO.HABILITADO){
      url = environment.URL_BASE + environment.REPORTES_PERSONALIZADO.NOMBRE + "/descargarReportePersonalizado";
    } else if(environment.CODCLIENTE == 'NXVSENIORTAXI'){
      url = url + 'rSrTaxi';
    }else if(environment.CODCLIENTE == 'NXVMOVICAB'){
      url = url+'Movicab'
    }
    if(environment.CODCLIENTE=='NXVDIRECTO'){
      url = environment.URL_BASE + environment.REPORTES_PERSONALIZADO.NOMBRE + '/descargarReportePersonalizado'
    }

    return this._http.post(url, data, { responseType: 'blob', headers }).pipe(
      map(((res: Blob) => new Blob(([res]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })

      )));

  }

  requestReporteSinPaginacionPV(data: any){
    console.log('reporte de para dockes')
    let url = environment.URL_REPORTE + 'otrosRporte/reportePuntoVenta';
    let headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Credentials', 'true');

    return this._http.post(url, data, { responseType: 'blob', headers }).pipe(
      map(((res: Blob) => new Blob(([res]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })

      )));
  }

  exportExcelPersonalizado(body: any): Observable<Blob> {
    const url = environment.URL_BASE + 'alotaxireporte/descargarReportePersonalizado';

    return this._http.post(url, body, { responseType: 'blob' }).pipe(
      map(((res: Blob) => new Blob(([res]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })

      )));


  }

  requestTipoServicio(idEmpresa: any,id: number) {
    const url = environment.URL_BASE + "tiposervicio/getTipoReporte?idEmpresa=" + idEmpresa +  "&id=" + id;
    return this._http.get(url);
  }

  requestPDF(data) {

    let url = environment.URL_REPORTE + "reportes/detallado/data";
    
    let headers = new HttpHeaders();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Credentials', 'true');
    
    if(environment.REPORTES_PERSONALIZADO_PDF && environment.REPORTES_PERSONALIZADO_PDF.HABILITADO){
      url = environment.URL_REPORTE + "reportes/LevelTaxiReporte/data";
    }
    return this._http.post(url, data, { headers });
  }

  requestReporteGastos(data){
    const url = environment.URL_REPORTE+"reportes/gastos";
    return this._http.post(url, data)
  }

  requestReporteGastosSinAutetication(data){
    const url = environment.URL_REPORTE+"reportes/gastos";
    return this._http.post(url, data)
  }


}
